export default __webpack_public_path__ + "static/media/WYMIEN_OPASKE.b4b1aff3.png";